import React from 'react';
import {
  Dropdown,
  DropdownOverlay,
  SelectInput,
  ActionList,
  ActionListItem,
  CalendarIcon,
  Box,
} from '@razorpay/blade/components';

interface PayrollMonthSelectorProps {
  label?: string;
  payrollMonth: string | null;
  options: Array<{ value: string; label: string }>;
  onPayrollMonthChange: (payrollMonth: string | null) => void;
}

export const PayrollMonthSelector: React.FC<PayrollMonthSelectorProps> = ({
  label = 'Select month',
  payrollMonth,
  options,
  onPayrollMonthChange,
}) => {
  const handleSelectionChange = ({ values }: { values: string[] }) => {
    const selectedValue = values[0] || null;
    onPayrollMonthChange(selectedValue);
  };

  if (!payrollMonth || !options || options.length === 0) {
    return null;
  }

  return (
    <Box marginBottom="spacing.6">
      <Dropdown selectionType="single">
        <SelectInput
          label={label}
          name="payrollMonth"
          value={payrollMonth}
          onChange={handleSelectionChange}
          icon={CalendarIcon}
          size="medium"
          necessityIndicator="required"
          isRequired
          labelPosition="top"
        />
        <DropdownOverlay>
          <ActionList>
            {options.map((option) => (
              <ActionListItem key={option.value} value={option.value} title={option.label} />
            ))}
          </ActionList>
        </DropdownOverlay>
      </Dropdown>
    </Box>
  );
};
